import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {RouterLink} from '@angular/router';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';

@Component({
    selector: 'app-secondary-school-shortcuts',
    templateUrl: './secondary-school-shortcuts.component.html',
    styleUrls: ['./secondary-school-shortcuts.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, MatIconModule, MatTooltipModule]
})
export class SecondarySchoolShortcutsComponent {

  @Input() isTeacherOrEducatorStaffMember: boolean;
  @Input() isTeacherStaffMember: boolean;
  @Input() isStaffMember: boolean;
}
